import { useState } from 'react';

import { sendClickLog } from '../../../app/utils/sendClickLog';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import styled from '@emotion/styled';
import GlobalNavButtonItem from '../../../app/components/GlobalNavItems/GlobalNavButtonItem';
import NotificationPopup from '../../../app/components/NotificationPopup';
import ProfileCardButton from '../../../app/components/ProfileCardButton';
import ProfilePopup from '../../../app/components/ProfilePopup';
import useFetchHasFreshMessage from '../../../app/hooks/useFetchHasFreshMessage';
import useFetchHasFreshNotification from '../../../app/hooks/useFetchHasFreshNotification';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import DomainManager from '../../../shared/utils/DomainManager';
import { useEnvContext } from '../../../modules/EnvProvider';

const baseLogData = {
  screenName: WeblogScreenName.COMMON,
  pageCategory: WeblogPageCategory.COMMON,
};

export default function LoggedInItems() {
  const { targetEnv } = useEnvContext();
  const domainManger = new DomainManager(targetEnv);
  const memberDomain = domainManger.getMemberServiceDomain();
  const { isFlightMode } = useLayoutHeaderContext();
  const [isNotificationPopupOpen, setIsNotificationPopupOpen] = useState(false);
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState(false);

  const { data: freshNotificationData, isError: isFreshNotificationError } =
    useFetchHasFreshNotification(isFlightMode);
  const hasFreshNotification = freshNotificationData?.newExists && !isFreshNotificationError;

  const { data: freshMessageData, isError: isFreshMessageError } = useFetchHasFreshMessage();
  const hasFreshMessage = freshMessageData?.new_messages && !isFreshMessageError;

  const handleNotificationOpen = () => {
    sendClickLog({
      ...baseLogData,
      eventName: 'topmenu',
      itemKind: 'notification',
      itemName: '알림',
    });

    setIsNotificationPopupOpen(true);
  };
  const handleNotificationClose = () => setIsNotificationPopupOpen(false);

  const handleProfilePopupOpen = () => {
    sendClickLog({
      ...baseLogData,
      eventName: 'topmenu',
      itemKind: 'menu',
      itemName: '프로필',
    });

    setIsProfilePopupOpen(true);
  };
  const handleProfilePopupClose = () => setIsProfilePopupOpen(false);

  return (
    <Container>
      <GlobalNavButtonItem type="link" label="저장됨" pathname={`${memberDomain}/wish/groups`} />
      <GlobalNavButtonItem type="link" label="내 여행" pathname="/reservations" />
      <GlobalNavButtonItem
        type="link"
        label="메시지"
        pathname="/messenger/channels"
        redDot={hasFreshMessage}
      />
      {!isFlightMode && (
        <GlobalNavButtonItem
          type="button"
          label="알림"
          onClick={handleNotificationOpen}
          redDot={hasFreshNotification}
        />
      )}
      <ProfileContainer>
        <ProfileCardButton onClick={handleProfilePopupOpen} />
      </ProfileContainer>

      {isNotificationPopupOpen && (
        <NotificationPopup isOpen={isNotificationPopupOpen} onClose={handleNotificationClose} />
      )}
      {isProfilePopupOpen && (
        <ProfilePopup isOpen={isProfilePopupOpen} onClose={handleProfilePopupClose} />
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  position: relative;
  height: 36px;
  gap: 0px 8px;
`;

const ProfileContainer = styled.div`
  margin-left: 12px;
`;
